import { Link } from 'react-router-dom';

const Join = (props) => {
  const { onClickGTM, club } = props;
  const handleLink = () => {
    onClickGTM(club);
  };
  return (
    <Link to={`/club/${club.slug}`} onClick={handleLink} className="c7-button">
      Join Now
    </Link>
  );
};

export default Join;
